(function ($) {

    $(document).ready(function () {
        let page = 1;
        let range = 9;
        let loading = false;

        $(".resources-overview .load-more-btn").on("click", function () {

            if (!loading) {
                loading = true;
                let section = $(this).closest(".resources-overview");
                let parent = section.find(".wrapper");
                let target = section.find(".load-more-box");
                let post_type = section.data("type");


                target.addClass("-loading");

                $.ajax({
                    url: myajax.url,
                    type: "post",
                    data: {
                        action: "load_more_news",
                        offset: (page * range),
                        range: range,
                        post_type: post_type,
                    },
                    success: function (data) {
                        if (data.result) {
                            page++;

                            loading = false;
                            parent.append(data.result);

                            if (data.count <= range) {
                                section.find(".load-more-box").addClass("-hidden");
                            } else {
                                section.find(".load-more-box").removeClass("-hidden");
                            }
                            target.removeClass("-loading");
                        } else {
                            loading = false;
                            target.removeClass("-loading");
                        }
                    }
                });
            }
        });


    });

})(jQuery);